import { Feature } from '@tencent/workbench';
import { IChartDataLabelShower } from '@tencent/chart-drawer-components/lib/interface';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import {
    getAvailableDataLabelPositions,
    getDataLabelDefaultPosition,
} from '@src/slide/domain/ui-model/element-modeles/chart-models/utils/data-label';
import { mappingPositionToSTDLblPos } from '../utils';
import type { STChartType, STDLblPos, ISelectOption } from '@tencent/chart-drawer-components/lib/interface';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { DataLabelPositionName } from '@src/slide/domain/ui-model/element-modeles/constant/chart';
import {
    IBaseDataLabelProperty,
    IDataLabelProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/data-label/data-label.interface';

@Feature({
    name: 'ChartDataLabelFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IChartDataLabelShower,
})
export class ChartDataLabelShower extends ChartBaseDrawerFeature implements IChartDataLabelShower {
    public getSelectOptionsByType(type: STChartType): ISelectOption[] | null {
        // 返回 null 表示不覆盖默认逻辑
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.CHART) return null;
        const chartType = model.plotArea.charts[0].getPresetChartType();
        const optinos = getAvailableDataLabelPositions(chartType).map(item => ({
            key: String(item),
            content: DataLabelPositionName[item],
        }));
        return optinos;
    }

    public getDataLabelPosition(): STDLblPos | undefined {
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.CHART) return;
        const dataLabel = model.getSelectedElementProperty() as unknown as IBaseDataLabelProperty;
        if (!dataLabel) return;
        const { layout, seriesId, labelPosition } = dataLabel || {};
        if (layout) return;
        if (labelPosition) return mappingPositionToSTDLblPos(labelPosition);
        const defaultPosition = getDataLabelDefaultPosition(model, seriesId!);
        return mappingPositionToSTDLblPos(defaultPosition!);
    }

    /**
     * 是否在数据标签中包含系列名称
     */
    public shouldContainSeriesName = (): boolean => !!this.dataLabelProperty?.showSeriesName;
    /**
     * 是否在数据标签中包含类别名称
     */
    public shouldContainCategoryName = (): boolean => !!this.dataLabelProperty?.showCategoryName;
    /**
     * 是否在数据标签中包含值
     */
    public shouldContainValue = (): boolean => !!this.dataLabelProperty?.showVal;
    /**
     * 是否在数据标签中包含百分比
     */
    public shouldContainPercentage = (): boolean => !!this.dataLabelProperty?.showPercent;

    private get dataLabelProperty() {
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.CHART) return;

        return model.getSelectedElementProperty() as unknown as IDataLabelProperty;
    }
}
